import {
  Backdrop,
  Box,
  Button,
  Grid,
  IconButton,
  Link,
  Modal,
  TextField,
  Typography
} from "@mui/material";

import { useConfirm } from "material-ui-confirm";
import { Formik } from "formik";
import ProgressModal from "../../../../components/modals/ProgressModal";
import { postNotification } from "../../../../components/utilities/Notifications";
import { BCPXmark } from "../../../../components/icons/bcp/BCPIcons";
import {
  getData,
  postData
} from "../../../../components/utilities/UtilityFunctions";
import { getEnvironmentVariable } from "../../../../global/environmentVariables";
import { useTranslation } from "react-i18next";

export function BulkAddTestPlayersModal(props) {
  const { open, setOpen, event, setLoadingMessage, setRefreshPlayers } = props;

  return (
    <Modal
      disableAutoFocus
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "95vw",
          minHeight: "95vh",
          maxHeight: "95vh",
          overflowY: "scroll",
          bgcolor: "background.paper",
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: 1,
          boxShadow: 24,
          p: 4
        }}
      >
        <IconButton
          aria-label="cancel"
          color="error"
          sx={{ position: "absolute", top: "4px", right: "4px" }}
          onClick={() => {
            setOpen(false);
          }}
        >
          <BCPXmark />
        </IconButton>
        <Grid
          container
          spacing={2}
          sx={{
            pb: 1,
            mb: 2,
            borderBottom: "1px solid rgba(0, 0, 0, 0.12)"
          }}
        >
          <Grid item xs={12}>
            <Typography variant="h4" component="h2">
              Bulk Add Test Players
            </Typography>
          </Grid>
        </Grid>

        <Formik
          initialValues={{
            firstName: "Player",
            number: 0
          }}
          enableReinitialize
          onSubmit={async (values) => {
            setLoadingMessage("Uploading...");
            try {
              for (let i = 1; i <= values.number; i++) {
                var user = {
                  firstName: values.firstName || "Player",
                  lastName: `${i}`
                };
                var newPlayer = {
                  eventId: event?.id,
                  checkedIn: false,
                  ...user,
                  user: user
                };
                try {
                  setLoadingMessage(`Uploading ${i} of ${values.number}...`);
                  await postData(`/players`, {
                    body: newPlayer
                  });
                } catch (err) {
                  console.error(err);
                }
              }
              setRefreshPlayers(true);
            } catch (err) {
              postNotification("error", err);
            }
            setLoadingMessage(null);
          }}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            isSubmitting,
            touched,
            values,
            setFieldValue
          }) => (
            <form onSubmit={handleSubmit}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <TextField
                    name="firstName"
                    label="First Name"
                    value={values.firstName}
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    onBlur={handleBlur}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    name="number"
                    label="Number of Players"
                    value={values.number}
                    variant="outlined"
                    fullWidth
                    type="number"
                    margin="normal"
                    onBlur={handleBlur}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button
                    color="primary"
                    variant="outlined"
                    fullWidth
                    type="submit"
                  >
                    Upload
                  </Button>
                </Grid>
              </Grid>
            </form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
}

export function BulkAddPlayerModal(props) {
  const { open, setOpen, event, setRefreshPlayers } = props;
  const confirm = useConfirm();

  return (
    <Modal
      disableAutoFocus
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "95vw",
          minHeight: "95vh",
          maxHeight: "95vh",
          overflowY: "scroll",
          bgcolor: "background.paper",
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: 1,
          boxShadow: 24,
          p: 4
        }}
      >
        <IconButton
          aria-label="cancel"
          color="error"
          sx={{ position: "absolute", top: "4px", right: "4px" }}
          onClick={() => {
            setOpen(false);
          }}
        >
          <BCPXmark />
        </IconButton>
        <Grid
          container
          spacing={2}
          sx={{
            pb: 1,
            mb: 2,
            borderBottom: "1px solid rgba(0, 0, 0, 0.12)"
          }}
        >
          <Grid item xs={12}>
            <Typography variant="h4" component="h2">
              Bulk Add Players
            </Typography>
          </Grid>
        </Grid>

        <Formik
          initialValues={{
            csvLoad: "",
            csvLoadErrorMessage: "",
            csvLoadProgress: 0
          }}
          enableReinitialize
          onSubmit={async (values) => {
            return;
          }}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            isSubmitting,
            touched,
            values,
            setFieldValue
          }) => (
            <form onSubmit={handleSubmit}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <TextField
                    name="csvLoad"
                    label="Comma Seperated Player Load"
                    value={values.csvLoad}
                    variant="outlined"
                    fullWidth
                    multiline
                    rows={6}
                    margin="normal"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={Boolean(touched.csvLoad && errors.csvLoad)}
                    helperText={
                      <>
                        <Typography sx={{ fontSize: "inherit" }}>
                          First Name,Last Name,Email
                          {event?.gameSystem?.usesSystemId
                            ? `,${
                                event?.gameSystem?.systemIdName || "System Id"
                              }`
                            : ""}
                        </Typography>
                        <Typography sx={{ fontSize: "inherit" }}>
                          First Name,Last Name,Email
                          {event?.gameSystem?.usesSystemId
                            ? `,${
                                event?.gameSystem?.systemIdName || "System Id"
                              }`
                            : ""}
                        </Typography>

                        {touched.csvLoad && errors.csvLoad ? (
                          <Typography
                            color="error"
                            sx={{ fontSize: "inherit" }}
                          >
                            {errors.csvLoad}
                          </Typography>
                        ) : (
                          ""
                        )}
                      </>
                    }
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button
                    color="primary"
                    variant="outlined"
                    fullWidth
                    onClick={async () => {
                      try {
                        await confirm({
                          title: `Terms of Service.`,
                          description: <TermsOfServiceBox />,
                          dialogProps: {
                            sx: {
                              zIndex: 99999
                            }
                          },
                          confirmationText: "I Agree",
                          cancellationText: "Cancel"
                        });
                      } catch (err) {
                        return;
                      }

                      var unknownLoad = [];
                      var successLoad = [];
                      var csvLoad = (values.csvLoad || "")
                        .split("\n")
                        .map((str) => str.trim());
                      setFieldValue("csvLoadErrorMessage", "");
                      setFieldValue("csvLoadProgress", 1);

                      for (let i = 0; i < csvLoad?.length; i++) {
                        let csvPlayer = csvLoad[i]
                          .split(",")
                          .map((str) => str.trim());

                        if (csvPlayer?.length >= 2) {
                          try {
                            var newPlayer = {
                              eventId: event?.id,
                              checkedIn: false,
                              user: {
                                firstName: csvPlayer[0],
                                lastName: csvPlayer[1]
                              }
                            };
                            if (csvPlayer[2]) {
                              newPlayer.user.email = csvPlayer[2];
                            }
                            if (
                              event?.gameSystem?.usesSystemId &&
                              csvPlayer[3]
                            ) {
                              newPlayer.systemId = csvPlayer[3];
                              if (event?.gameSystem?.systemIdName) {
                                newPlayer.systemIdKey =
                                  event?.gameSystem?.systemIdName;
                              }
                            }
                            try {
                              await postData(`/players`, {
                                body: newPlayer
                              });
                              successLoad.push(csvPlayer);
                            } catch (err) {
                              console.error(err);
                            }
                            let perc = parseInt(
                              ((i + 1) / (csvLoad?.length * 2)) * 100
                            );
                            if (perc < 1) {
                              perc = 1;
                            }

                            setFieldValue("csvLoadProgress", perc);
                          } catch (err) {
                            unknownLoad.push(csvPlayer);
                          }
                        }
                      }

                      if (successLoad?.length) {
                        setRefreshPlayers(true);
                      }

                      setFieldValue("csvLoadProgress", 0);
                      setFieldValue("csvLoad", "");
                      setOpen(false);
                    }}
                  >
                    Upload
                  </Button>
                  <ProgressModal
                    open={values.csvLoadProgress > 0}
                    value={values.csvLoadProgress}
                    message={"uploading players"}
                  />
                </Grid>
              </Grid>
            </form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
}

export function BulkAddPlayerEmailsModal(props) {
  const { open, setOpen, event, setRefreshPlayers } = props;
  const confirm = useConfirm();

  return (
    <Modal
      disableAutoFocus
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "95vw",
          minHeight: "95vh",
          maxHeight: "95vh",
          overflowY: "scroll",
          bgcolor: "background.paper",
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: 1,
          boxShadow: 24,
          p: 4
        }}
      >
        <IconButton
          aria-label="cancel"
          color="error"
          sx={{ position: "absolute", top: "4px", right: "4px" }}
          onClick={() => {
            setOpen(false);
          }}
        >
          <BCPXmark />
        </IconButton>
        <Grid
          container
          spacing={2}
          sx={{
            pb: 1,
            mb: 2,
            borderBottom: "1px solid rgba(0, 0, 0, 0.12)"
          }}
        >
          <Grid item xs={12}>
            <Typography variant="h4" component="h2">
              Bulk Add Players via Email List
            </Typography>
          </Grid>
        </Grid>

        <Formik
          initialValues={{
            csvEmails: "",
            csvEmailsErrorMessage: "",
            csvEmailProgress: 0
          }}
          enableReinitialize
          onSubmit={async () => {
            return;
          }}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            touched,
            values,
            setFieldValue
          }) => (
            <form onSubmit={handleSubmit}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <TextField
                    name="csvEmails"
                    label="Comma Seperated Email Load"
                    value={values.csvEmails}
                    variant="outlined"
                    fullWidth
                    multiline
                    rows={6}
                    margin="normal"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={Boolean(touched.csvEmails && errors.csvEmails)}
                    helperText={
                      <>
                        <Typography sx={{ fontSize: "inherit" }}>
                          Email,Email,Email...
                        </Typography>

                        {touched.csvEmails && errors.csvEmails ? (
                          <Typography
                            color="error"
                            sx={{ fontSize: "inherit" }}
                          >
                            {errors.csvEmails}
                          </Typography>
                        ) : (
                          ""
                        )}
                      </>
                    }
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button
                    color="primary"
                    variant="outlined"
                    fullWidth
                    onClick={async () => {
                      try {
                        await confirm({
                          title: `Terms of Service.`,
                          description: <TermsOfServiceBox />,
                          dialogProps: {
                            sx: {
                              zIndex: 99999
                            }
                          },
                          confirmationText: "I Agree",
                          cancellationText: "Cancel"
                        });
                      } catch (err) {
                        return;
                      }

                      var unknownEmails = [];
                      var successEmails = [];
                      var csvEmails = (values.csvEmails || "")
                        .split(",")
                        .map((str) => str.trim());
                      setFieldValue("csvEmailsErrorMessage", "");
                      setFieldValue("csvEmailProgress", 1);

                      for (let i = 0; i < csvEmails?.length; i++) {
                        let csvEmail = csvEmails[i];
                        if (csvEmail !== "") {
                          try {
                            var apiUser = await getData(`/users/${csvEmail}`, {
                              queryStringParameters: {
                                "expand[]": ["team"]
                              }
                            });
                            var perc = parseInt(
                              ((i * 2 + 1) / (csvEmails?.length * 2)) * 100
                            );
                            if (perc < 1) {
                              perc = 1;
                            }
                            setFieldValue("csvEmailProgress", perc);
                            if (apiUser) {
                              var newPlayer = {
                                eventId: event?.id,
                                checkedIn: false,
                                userId: apiUser.id
                              };

                              try {
                                await postData(`/players`, {
                                  body: newPlayer
                                });
                                successEmails.push(csvEmail);
                              } catch (err) {
                                console.error(err);
                              }
                              perc = parseInt(
                                ((i * 2 + 2) / (csvEmails?.length * 2)) * 100
                              );
                              if (perc < 1) {
                                perc = 1;
                              }

                              setFieldValue("csvEmailProgress", perc);
                            } else {
                              unknownEmails.push(csvEmail);
                            }
                          } catch (err) {
                            unknownEmails.push(csvEmail);
                          }
                        }
                      }

                      if (successEmails?.length) {
                        setRefreshPlayers(true);
                      }

                      setFieldValue("csvEmailProgress", 0);
                      if (unknownEmails?.length) {
                        setFieldValue("csvEmails", unknownEmails.join(","));
                        setFieldValue(
                          "csvEmailsErrorMessage",
                          "Some emails were not linked to a user"
                        );
                        postNotification(
                          "error",
                          "Some emails were not linked to a user"
                        );
                      } else {
                        setFieldValue("csvEmails", "");
                        setOpen(false);
                      }
                    }}
                  >
                    Upload
                  </Button>
                  <ProgressModal
                    open={values.csvEmailProgress > 0}
                    value={values.csvEmailProgress}
                    message={"uploading players"}
                  />
                </Grid>
              </Grid>
            </form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
}

export function PlayerGroupInfoModal(props) {
  const { t } = useTranslation();
  const { open, setOpen, setProcessing, player, setPlayer, setRefreshPlayers } =
    props;

  return (
    <Modal
      disableAutoFocus
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "95vw",
          minHeight: "95vh",
          maxHeight: "95vh",
          overflowY: "scroll",
          bgcolor: "background.paper",
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: 1,
          boxShadow: 24,
          p: 4
        }}
      >
        <IconButton
          aria-label="cancel"
          color="error"
          sx={{ position: "absolute", top: "4px", right: "4px" }}
          onClick={() => {
            setOpen(false);
          }}
        >
          <BCPXmark />
        </IconButton>
        <Grid
          container
          spacing={2}
          sx={{
            pb: 1,
            mb: 2,
            borderBottom: "1px solid rgba(0, 0, 0, 0.12)"
          }}
        >
          <Grid item xs={12}>
            <Typography variant="h4" component="h2">
              Update Group Info
            </Typography>
          </Grid>
        </Grid>

        <Formik
          initialValues={{
            groupID: player?.groupID,
            countryCode: player?.countryCode,
            groupName: player?.groupName
          }}
          enableReinitialize
          onSubmit={async (values) => {
            var body = { set: {}, unset: {} };
            if (
              values.groupID !== undefined &&
              values.groupID !== "" &&
              values.groupID !== 0
            ) {
              body.set.groupID = values.groupID;
            } else {
              body.unset.groupID = true;
            }

            if (
              values.countryCode !== undefined &&
              values.countryCode !== "" &&
              values.countryCode !== 0
            ) {
              body.set.countryCode = values.countryCode;
            } else {
              body.unset.countryCode = true;
            }

            if (
              values.groupName !== undefined &&
              values.groupName !== "" &&
              values.groupName !== 0
            ) {
              body.set.groupName = values.groupName;
            } else {
              body.unset.groupName = true;
            }

            setProcessing(true);
            try {
              await postData(`/players/${player?.id}/setGroupInfo`, {
                body: body
              });
              postNotification(
                "success",
                t("notifications.success.playerGroupInfoSet")
              );
            } catch (err) {
              postNotification("error", err);
              setProcessing(false);
              return;
            }
            setProcessing(false);
            setRefreshPlayers(true);
            setPlayer(null);
            setOpen(false);
          }}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            touched,
            values,
            setFieldValue
          }) => (
            <form onSubmit={handleSubmit}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <TextField
                    name="groupID"
                    label="Group ID"
                    value={values.groupID}
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={Boolean(touched.groupID && errors.groupID)}
                    helperText={touched.groupID && errors.groupID}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    name="countryCode"
                    label="Country Code"
                    value={values.countryCode}
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={Boolean(touched.countryCode && errors.countryCode)}
                    helperText={touched.countryCode && errors.countryCode}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    name="groupName"
                    label="Group Name / Country Name"
                    value={values.groupName}
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={Boolean(touched.groupName && errors.groupName)}
                    helperText={touched.groupName && errors.groupName}
                  />
                </Grid>
                <Grid item xs={6} sm={12}>
                  <Button
                    fullWidth
                    variant="outlined"
                    color="error"
                    onClick={() => setOpen(false)}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs={6} sm={12}>
                  <Button
                    fullWidth
                    variant="contained"
                    color="success"
                    type="submit"
                  >
                    Update
                  </Button>
                </Grid>
              </Grid>
            </form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
}

const TermsOfServiceBox = () => {
  return (
    <Box>
      <Typography variant="caption" paragraph>
        By clickin "I agree", you agree to the Terms of Service for the{" "}
        {getEnvironmentVariable("COMPANY_NAME")} Website or Services, EULA, and
        Privacy Policy. You must be 13 years of age or older to use{" "}
        {getEnvironmentVariable("COMPANY_NAME")}. By agreeing you confirm that
        you are over 18, or if you are between 13 and 18 years of age, you have
        your parent or legal guardian's permission to use{" "}
        {getEnvironmentVariable("COMPANY_NAME")}
        We take privacy seriously and collect the following information to
        administer your account, scores, rankings and ticket sales. Your name is
        shared publicly as part of event rosters, pairings, placings and
        rankings. Your email address is kept private and used as our unique
        identifier and only shared with the Event Organizers of events you
        participate in, Team owners which you are a member of, and Vendors you
        make purchases from. {getEnvironmentVariable("COMPANY_NAME")} may
        contact you occasionally in relation to services requested.
      </Typography>
      <Typography variant="caption">
        Visit these links for our complete{" "}
        <Link href="/privacy" target="_blank">
          Privacy Policy
        </Link>{" "}
        and{" "}
        <Link href="/eula" target="_blank">
          EULA
        </Link>
        .
      </Typography>
    </Box>
  );
};
